import { Box, Stack, Typography } from '@mui/material';

export type FieldSectionProps = {
    label: string;
    value: string | string[];
    renderAsTags?: boolean;
};

const getDisplayValue = (value: string | string[]): string => {
    if (Array.isArray(value)) return value.join(', ');
    return value || '';
};

const FieldSection = ({ label, value, renderAsTags }: FieldSectionProps) => {
    const display = Array.isArray(value) ? value : [value].filter(Boolean);
    if (renderAsTags && Array.isArray(value) && display.length > 0) {
        return (
            <Stack spacing={1}>
                <Typography variant="subtitle2" fontWeight={500} color="text.secondary">
                    {label}
                </Typography>
                <Stack direction="row" flexWrap="wrap" gap={1}>
                    {display.map((item) => (
                        <Box
                            key={item}
                            component="span"
                            sx={{
                                px: 1.5,
                                py: 0.5,
                                backgroundColor: 'grey.200',
                                borderRadius: 1,
                                fontSize: '0.875rem',
                            }}
                        >
                            {item}
                        </Box>
                    ))}
                </Stack>
            </Stack>
        );
    }
    const text = getDisplayValue(value);
    return (
        <Stack spacing={1}>
            <Typography variant="subtitle2" fontWeight={500} color="text.secondary">
                {label}
            </Typography>
            <Typography variant="body2" color="text.primary" sx={{ whiteSpace: 'pre-wrap' }}>
                {text || '-'}
            </Typography>
        </Stack>
    );
};

export default FieldSection;
